import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import GlassCard from "../dashboard/GlassCard";
import RiskBadge from "./RiskBadge";
import { useTranslation } from "react-i18next";

const IncidentCard = ({ incident, onOpen }) => {
  const { t } = useTranslation();
  return (
    <GlassCard hover={false} sx={{ p: 2 }}>
      <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} gap={2}>
        <Box>
          <Typography variant="h5">{incident.title}</Typography>
          <Typography variant="body2" color="text.secondary">{incident.id} · {incident.zone} · {incident.duration}</Typography>
        </Box>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Chip label={incident.severity} color={incident.severity === "HIGH" ? "error" : "warning"} size="small" />
          <Chip label={incident.status} variant="outlined" size="small" />
          <Chip label={t("platform.incidents.aiEvents", { count: incident.events })} variant="outlined" size="small" />
          <Chip label={t("platform.incidents.cameras", { count: incident.cameras })} variant="outlined" size="small" />
          <RiskBadge score={incident.riskScore} />
          {onOpen && <Button size="small" variant="contained" onClick={() => onOpen(incident)}>{t("common.open")}</Button>}
        </Stack>
      </Stack>
    </GlassCard>
  );
};

export default IncidentCard;
